// extracted by mini-css-extract-plugin
module.exports = {"formInput":"MessageFormInput_formInput__3QA_2","formTextarea":"MessageFormInput_formTextarea__1oah7"};